import React from 'react';
import './CoinReward.css';

function CoinReward({ show }) {
  if (!show) {
    return null;
  }
  return (
    <div className="coin-reward-animation">
      +5 💰
    </div>
  );
}

export default CoinReward;